
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/tax-exempt",
      function () {
        return require("private-next-pages/business/tax-exempt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/tax-exempt"])
      });
    }
  